export const pie3d = {
    outerRadius: .6,
    pie3d: {
        style: {
            height: 10,
            fillOpacity: 1
        }
    },
    label: {
        visible: !1,
        position: "outside"
    }
};
//# sourceMappingURL=pie3d.js.map
